import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, AfterContentInit } from '@angular/core';
import { trigger, transition, state, animate, style, AnimationEvent } from '@angular/animations';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertType } from 'base-models';
import { MessageError } from 'base-models';
import { SortHelper } from 'shtools';
import { OlMainComponent, OlMapBaseComponent, OlMapOptions } from 'gmap';
import { Site, Supervision, SupervisionError, SupervisionStatusEnum } from 'solar-bo';
import { FrLayer, FrCoordinate } from 'gmap';
import { mapcte } from 'gmap';
import { ChartComponent, ChartService } from 'fr-chart';

import { OlObjectTypeEnum } from 'solar-bo';;
import { IssueImageComponent } from '../../supervis/issueimage/issueimage.component';
import { MapOnMoveHelper } from 'gmap';
import { MapTooltipHelper } from 'gmap';
import { DBFilterComponent } from '../db-filter/db-filter.component';
import { DashboardService } from '../../services/dashboard.service';
import { SolarBase1Component } from '@solar/solar/solar-base';
import { DbFilter } from './db-filter-helper';

import { ErrorcontrolService } from 'basecomponents';
import { DashBoardHelper } from '../dashboard-helpers';

import { SupervisLoader } from '@solar/solar/supervis/superv-main/supervis-loader';
import { MapMarkerHelper } from 'gmap';
import { MapSupervisionHelper, MapIssueOverlay, MapSiteHelper, MapSupervisionIssues, MapSiteOverlay } from '@solar/ol';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { IssueTypeHelper } from '@solar/solar/models/IssueTypeHelper.model';

import { IDB_filter, IDB_Chart_Res, DB_filter, DBColumnsEnum, IFilterItem, FilterItem, GenFilter, FilterItemCollection, IFilterItemCollection } from '../db-filter/filter';

import * as ol from 'ol';
import { transform as ol_transform } from 'ol/proj';
import Feature from 'ol/Feature';
import Map from 'ol/Map';
import Point from 'ol/geom/Point';
import { Cluster, OSM, Vector as VectorSource } from 'ol/source';
import { createEmpty, extend, getHeight, getWidth } from 'ol/extent';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import {
  Circle as CircleStyle,
  Fill,
  Stroke,
  Style,
  Text,
} from 'ol/style';
import * as olInteraction from 'ol/interaction';
import { MapSiteCluster } from '@solar/ol/map-site-cluster';
import { TooltipSite } from '@solar/ol/tooltip-site.model';
import { DBFilter2Component } from '../db-filter/db-filter2.component';

declare var google: any;

//providers:[DashboardService]
@Component({
  selector: 'app-db-overview',
  templateUrl: './db-overview-2.component.html',
  styleUrls: ['./db-overview-2.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({transform: 'translateY(100%)', opacity: 0}),
          animate('500ms', style({transform: 'translateY(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateY(0)', opacity: 1}),
          animate('500ms', style({transform: 'translateY(100%)', opacity: 0}))
        ])
      ]
    )
  ],
})
export class DbOverviewComponent extends SolarBase1Component implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {


  @ViewChild('map_db') mapc: OlMainComponent;
  @ViewChild('chartSitePower') chartSitePower: ChartComponent;
  //@ViewChild('dbfilter2') dbfilter2: DBFilter2Component;
  firstload = true;//en la primera carga 



  siteList: Site[] = [];
  supervisionList: Supervision[] = [];

  companytotalsites: number = 0;
  companytotalpower: number = 0;
  companytotalpowerlost: number = 0;
  companytotalmodules: number = 0;
  companytotalmodulesinactive: number = 0;

  filterTotal = { totalsites: 0, totalpower: 0, totalmodules: 0, totalpowerlost: 0, totalpowerlostpercent: 0, totalmodulesinactive: 0, totalmodulesinactivepercent: 0 };

  private gLib: any;
  gLibIsLoaded = false;
  //filters loaded for use
  public dbFilter: GenFilter = new GenFilter();
  //last filters selected by user
  filtersActive: IFilterItemCollection[];
  /**
   * layer object with issues
   */
  layer_Issues: any[] = [];
  /**
   * sites layer
   */
  layerSites;
  mapSupervisionIssues: MapSupervisionIssues;
  mapSiteHelper: MapSiteHelper;
  //mapcomponent_options: OlMapOptions = new OlMapOptions({ zoomPosition: 'RIGHT' });

  //charts visibility
  showChartPower={visible:true ,pristine:true, dirty:false};
  hideChartPowerWhen1=true;
  showChartIssues=true;
   showChartRelevance=true;
  showChartManufacturer=true;
   showChartPanelModel=true;

  constructor(
    private dashService: DashboardService
    , private gChartService: ChartService

  ) {
    super();
    this.gLib = this.gChartService.getLibrary();

    this.mapSupervisionIssues = new MapSupervisionIssues();
    this.mapSiteHelper = new MapSiteHelper();
    

  }

  ngOnInit() {


  }

  changeSitePowerChartVisibility(item){
    item.visible=!item.visible;
    item.pristine=false;
    item.dirty=true;
  } 

  logEvent($event){
    console.log($event);
  }


  mapcontrol: boolean = true;
  issueOverlay: MapIssueOverlay;
  tooltipOverlay: MapSiteOverlay;
  mapOnMoveHelper: MapOnMoveHelper;
  mapSiteCluster: MapSiteCluster;
  mapSiteTooltip: TooltipSite;
  ngAfterViewInit() {
    this.gLib.charts.load('current', { 'packages': ['corechart'] });
    //this.dbFilter.selectionChange.subscribe(res => this.selectionChangeHandler(res))

    if (this.mapc) {
      this.mapcontrol = true;
      this.mapc.setZoom(2);
      this.mapc.onFeatureClick.subscribe(res => this.onFeatureClick(res));
      this.mapOnMoveHelper = new MapOnMoveHelper(this.mapc);
      this.mapSiteCluster = new MapSiteCluster(this.mapc, this.mapSiteHelper);

      //this.tooltipOverlay = new MapSiteOverlay(this.mapc);
      //this.tooltipOverlay.addLayer('sitesmarkers');
      //this.mapOnMoveHelper.addListener(this.tooltipOverlay);

      this.issueOverlay = new MapIssueOverlay(this.mapc);
      this.mapOnMoveHelper.addListener(this.issueOverlay);

      this.mapSiteTooltip = new TooltipSite(this.mapc);
    }

    let cls=this;
    this.gLib.charts.setOnLoadCallback(() => {
      console.log("this.gLib.charts.setOnLoadCallback")
        , this.gLibIsLoaded = true
        , this.getSiteList()
        , this.configChartHandlers()
    }
    );

    /*   this.dbfilter2.selectedEvent.subscribe(res => {
        this.filterSelectedEventHandler(res)
      }); */
    
  }

  chartHandlersConfigured:boolean=false;
  configChartHandlers(){
    if (this.chartHandlersConfigured){
      return;
    }

    this.chartSitePower.select.subscribe(res => {
      this.chartSitePower_selectHandler(res)
    });
    
    this.chartHandlersConfigured=true;  
  }

  chartSitePower_selectHandler(res: any) {
    console.log("DASHBOARD chartSitePower_selectHandler", res);
    let selectedItem=res.selectedItem;
    let id=this.chartSitePowerDataTable.getValue(selectedItem.row,0);
    console.log("DASHBOARD chartSitePower_selectHandler value", id);
  }



  ngAfterContentInit() {

  }

  ngOnDestroy() {
    this.mapcontrol = false;
  }

  onFeatureClick(featuresAs: { feature: Feature, layer: VectorLayer }[]) {
    console.log(featuresAs);
    if (!featuresAs) {
      return;
    }

    let features: any = [];
    for (let item of featuresAs) {
      let featuresList = item.feature.get('features');
      if (featuresList != undefined) {
        features.push(...featuresList);
        if (features.length > 1) {
          //es un cluster
          let extent = createEmpty();
          let map = this.mapc.map;
          featuresList.forEach(function (f, index, array) {
            extend(extent, f.getGeometry().getExtent());
          });

          map.getView().fit(extent, { size: map.getSize(), padding: [35, 40, 30, 35] });
          return;
        }
        else {
          //es un cluster pero con un solo item, el site asi que lo sacamos

        }

      } else {
        features.push(item.feature);
      }
    }


    for (let featInfo of features) {
      let feat = featInfo;

      let layerInfo: FrLayer = feat.frlayerinfo;
      if (layerInfo) {
        if (layerInfo.ref == OlObjectTypeEnum.issue) {
          let issue = layerInfo.refObject;
          if (issue) {
            IssueImageComponent.openModal(this.dialog, issue, issue.supervision);
            return;
          }
        }
        else if (layerInfo.ref == OlObjectTypeEnum.site) {
          let site = layerInfo.refObject;
          if (site) {
            console.log("Feature clicked is site:", site);

            let sites: IFilterItemCollection = this.filtersActive.find(elem => elem.id_filter === DBColumnsEnum.site_id);
            if (sites.items.length == 1) {
              let siteSelected = sites.items[0];
              if (siteSelected.id == site.id) {
                this.filterDashBoardBySiteResetToAll();
              }
              else {
                this.filterDashBoardBySite(site);
              }
            } else {
              this.filterDashBoardBySite(site);
            }

            return;
          }
        }

      }
    }
  }

  filterDashBoardBySite(site: Site) {
    console.log(this.dbFilter);
    let siteList: IFilterItemCollection = this.dbFilter.filterGet(DBColumnsEnum.site_id);
    let siteF = siteList.items.find(item => item.id === site.id);
    if (siteF) {
      let newList = [];
      newList.push(siteF);
      siteList.selected = newList;
      let filter = this.dbFilter.getIDBFilter();
      this.filterSelectedEventHandler(filter);
      //get and draw site error in the same operation
      this.siteGetLastSupervision(site);
    }
  }

  filterDashBoardBySiteResetToAll() {
    console.log(this.dbFilter);
    let siteList: IFilterItemCollection = this.dbFilter.filterGet(DBColumnsEnum.site_id);
    let siteF = siteList.items;
    if (siteF) {
      let newList = [];
      newList.push(...siteF);
      siteList.selected = newList;
      let filter = this.dbFilter.getIDBFilter();
      this.filterSelectedEventHandler(filter);
    }
  }


  getSiteList(): void {
    this.listerrmessage = "";
    this.loading = true;
    this.dashService.getSiteList()
      .subscribe(
        reslist => this.getSiteListhandleresult(reslist)
        , err => this.getSiteListhandleError(err)
      );
  }

  getSiteListhandleresult(newlist: any[]) {
    this.listerrmessage = '';
    this.loading = false;
    //newlist = SortHelper.sortMultiple(newlist, ["name"]);
    newlist = newlist.sort((a, b) => SortHelper.sortByStringLocale(a.name, b.name));
    this.siteList = newlist;
    this.configCompanyTotals();
    this.firstload = false;
    this.filterTotal = this.dashService.configTotals(newlist);


    this.drawSitesClusterOnMap(this.siteList);
    let sitesSelected = new FilterItemCollection(DBColumnsEnum.site_id);

    if (newlist.length > 0) {
      sitesSelected.addItems("id", "name", newlist);
      this.dbFilter.addFilter(sitesSelected);
    }

    this.configFilters();
    this.filterDashBoard([sitesSelected]);

  }

  getSiteListhandleError<T>(err: any) {
    this.loading = false;
    this.alertmessage = ErrorcontrolService.basichandleError("", err);
  }

  private sitesDrawed = false;
  /**
   * Draw sites on map, NOW WE ARE USING CLUSTER
   * @param sitesSelected 
   * @param force 
   * @returns 
   */
  drawSitesOnMap(sitesSelected: Site[], force?: boolean) {
    if (force) {
      this.sitesDrawed = false;
    }
    if (!this.mapc || this.sitesDrawed) {
      return;
    }
    try {


      if (!sitesSelected || sitesSelected.length == 0) {
        return;
      }

      let frlayerinfo = new FrLayer('Sites', 'sitesmarkers');
      let layer = this.mapc.layerGetByFrid(frlayerinfo.id);
      if (layer) {
        this.mapc.layerRemove(frlayerinfo.id);
      }

      layer = this.mapc.layerCreateVectorLayer(frlayerinfo);
      let mapSitesHelper = new MapSiteHelper();
      let features: any[] = [];
      for (let item of sitesSelected) {
        let site: Site = item;
        if (site.info.location != null) {
          const feature = MapMarkerHelper.markerCreate(null, site.info.location[0], site.info.location[1], site.id, site.name);
          let layerExt = feature[mapcte.frlayerinfo_FieldName];
          layerExt.ref = OlObjectTypeEnum.site;
          layerExt.refObject = site;
          features.push(feature);
          //layer.getSource().addFeature(feature);
        }
      }
      let source = layer.getSource();
      source.addFeatures(features);

      layer.setStyle(this.mapSiteHelper.siteMapStyleFull.bind(this.mapSiteHelper));

      this.mapc.layerAdd(layer);
      if (sitesSelected.length == 1) {
        let site: Site = sitesSelected[0];
        if (site.info.location) {
          this.mapc.setLocation(new FrCoordinate(site.info.location[0], site.info.location[1]));
          this.mapc.zoomUpgrade(17);
        }
      }
      else if (sitesSelected.length > 1) {
        this.mapc.setZoomToExtent(layer, 5000);
      }
      else {
        this.mapc.setZoom(4);
      }

      this.sitesDrawed = true;
    } catch (ex) {
      console.log(ex);
      this.alertmessage = new MessageError(AlertType.Info, "Error loading map" + ex);
    }

  }

  drawSitesClusterOnMap(sitesSelected: Site[], force?: boolean) {
    try {
      this.mapSiteCluster.drawSitesClusterOnMap(sitesSelected);

      return;
    } catch (ex) {
      console.log(ex);
      this.alertmessage = new MessageError(AlertType.Info, "Error loading map" + ex);
    }

  }

  siteGetLastSupervision(site: Site) {
    this.solarService.siteGetSupervisions(site.id)
      .subscribe(
        res_list => this.siteGetLastSupervisionHandleresult(res_list)
        , err => this.siteGetLastSupervisionHandleError(err)
      );
  }



  siteGetLastSupervisionHandleresult(newlist: any[]) {
    console.log('siteGetLastSupervisionHandleresult', newlist);
    this.listerrmessage = '';
    this.loading = false;
    newlist=newlist.filter(s=>s.info.status==SupervisionStatusEnum.VALIDATED);
    if (newlist.length > 0) {
      newlist = SortHelper.sortMultiple(newlist, ["info.supervisionDate"], ['desc']);
      
      const lastSuperv = newlist[0];
      this.drawPanelErrorsOnMap(lastSuperv);
    }

  }

  siteGetLastSupervisionHandleError<T>(err: any) {
    this.loading = false;
    this.handleError(err, "Error retrieving supervision data");
  }

  /**
   * Method called by UI supervision list
   * @param superv 
   */
  drawPanelErrorsOnMap(superv: Supervision) {
    this.listerrmessage = "";
    this.loading = true;
    this.alertmessage = null;
    let site: Site = this.siteList.find(elem => elem.id == superv.site.id);
    superv.site = site;
    if (site.info.location) {
      this.mapc.setLocation(new FrCoordinate(site.info.location[0], site.info.location[1]));
    }
    let parentLayer = this.mapc.layerGetByFrid(superv.id);
    if (parentLayer) {
      this.mapc.layerShow(parentLayer[mapcte.frlayerinfo_FieldName].id);
      this.mapc.setZoomToExtent(parentLayer);
      this.loading = false;
      return;
    }

    let cl = new SupervisLoader(this.solarService);
    cl.getSupervisionData(superv.id);
    cl.configEndEvent.subscribe(res => this.configureDataTree(res, superv));
    cl.configErrorEvent.subscribe(res => this.handleError(res));

    /*     this.baseService.supervisionGetIssues(superv.id)
          .subscribe(
            reslist => {
              supervLoaded.issues=reslist,
              this.drawPanelErrorsOnMapHandlerResult(supervLoaded, reslist)
            }
            , err => this.getSiteListhandleError(err)
          ); */
  }


  configureDataTree(res, supervLoaded: Supervision) {
    let issues = res.issues;
    supervLoaded.issues = issues;
    this.supervisionList.push(supervLoaded);
    console.log
    this.drawPanelErrorsOnMapHandlerResult(supervLoaded, issues);
    this.alertmessage = null;
    this.loading = false;
  }

  filterOpenModal() {

    let dialogRef: MatDialogRef<DBFilterComponent> = DBFilterComponent.openModal(this.dialog, this.dbFilter, "Filter results", "Select criteria to filter your results", { left: '30px', top: '10px' });
    dialogRef.componentInstance.selectedEvent.subscribe(res => {
      this.filterSelectedEventHandler(res)
    });

  }

  /**
   * Handler when user clicks on filter view
   * @param selection 
   */
  filterSelectedEventHandler(filters: IFilterItemCollection[]) {
    if (!filters) {
      return;
    }
    let siteFilterCol: IFilterItemCollection = filters.find(elem => elem.id_filter === DBColumnsEnum.site_id);
    if (siteFilterCol) {
      let siteList = siteFilterCol.items.map(function (item) {
        return item.value;
      });
      this.drawSitesClusterOnMap(siteList, true);
      this.filterTotal = this.dashService.configTotals(siteList);
    }

    this.filterDashBoard(filters);
  }

  /**
   * handler for filter
   * @param filters 
   */
  filterDashBoard(filters?: IFilterItemCollection[]) {
    this.filtersActive = filters;

    if (!this.gLibIsLoaded) {
      return;
    }
    console.log("selectionChangeHandler", filters);
    if (!filters) {
      return;
    }
    let sitesFilter: IFilterItemCollection = filters.find(elem => elem.id_filter === DBColumnsEnum.site_id);
    if (sitesFilter) {
      console.log("Calling chart_sitepower");
      this.chart_sitepower(sitesFilter.value);
    }
    //
    if (this.hideChartPowerWhen1 && sitesFilter.value.length<=1){
      this.showChartPower.visible=false;  
      
    }
    else{
      this.showChartPower.visible=true;
    }

    if (sitesFilter.value.length==1){
        let oneSite=sitesFilter.value[0];
        this.siteGetLastSupervision(oneSite);
    }

    this.dashService.db_resultsFilterByCount(DBColumnsEnum.issue_type, filters)
      .subscribe(
        reslist => this.chart_siteissues(reslist)
        , err => this.getSiteListhandleError(err)
      );

    this.dashService.db_resultsFilterByCount(DBColumnsEnum.relevance, filters)
      .subscribe(
        reslist => this.chart_siteissuesrelevance(reslist)
        , err => this.getSiteListhandleError(err)
      );

    this.dashService.db_resultsFilterByCount(DBColumnsEnum.panel_model, filters)
      .subscribe(
        reslist => this.chart_IssueModuleTypeData(reslist)
        , err => this.getSiteListhandleError(err)
      );

    this.dashService.db_resultsFilterByCount(DBColumnsEnum.panel_brand, filters)
      .subscribe(
        reslist => this.chart_IssueModuleBrandData(reslist)
        , err => this.getSiteListhandleError(err)
      );

    this.mapSupervisionIssues.filterSelected = filters;
    if (this.layer_Issues) {
      for (let layer of this.layer_Issues) {
        layer.changed();
      }

    }

  }

  /**
   * Config global filters used by charts from server
   */
  private configFilters() {

    this.dashService.db_resultsFilterBy([DBColumnsEnum.issue_type], DBColumnsEnum.issue_type)
      .subscribe(
        reslist => {
          let lst = reslist.map(function (item) {
            return item[DBColumnsEnum.issue_type];
          });
          let filter = new FilterItemCollection(DBColumnsEnum.issue_type);
          if (lst.length > 0) {
            lst = reslist.map(function (item) {
              let fitem = new FilterItem();
              fitem.id = item[DBColumnsEnum.issue_type];
              fitem.value = fitem.id;
              fitem.viewname = IssueTypeHelper.issueGetErrorTypeDescription(fitem.id);
              return fitem;
            });

          }
          lst = SortHelper.sortMultiple(lst, ["viewname"], ['asc']); //_.orderBy(users, ['user', 'age'], ['asc', 'desc']);  
          filter.addItemsByFilterItemList(lst);

          this.dbFilter.addFilter(filter);
        }
        , err => this.getSiteListhandleError(err)
      );

    this.dashService.db_resultsFilterBy([DBColumnsEnum.relevance], DBColumnsEnum.relevance)
      .subscribe(
        reslist => {
          let lst = reslist.map(function (item) {
            return item[DBColumnsEnum.relevance];
          });
          lst = lst.sort();
          let filter = new FilterItemCollection(DBColumnsEnum.relevance);
          filter.addItemsByList(lst);
          this.dbFilter.addFilter(filter);
        }
        , err => this.getSiteListhandleError(err)
      );

    this.dashService.db_resultsFilterBy([DBColumnsEnum.panel_model], DBColumnsEnum.panel_model)
      .subscribe(
        reslist => {
          let lst = reslist.map(function (item) {
            return item[DBColumnsEnum.panel_model];
          });
          lst = lst.sort();
          //this.dbFilter.filterAdd(DBColumnsEnum.panel_model, lst);
          let filter = new FilterItemCollection(DBColumnsEnum.panel_model);
          filter.addItemsByList(lst);
          this.dbFilter.addFilter(filter);
        }
        , err => this.getSiteListhandleError(err)
      );

    this.dashService.db_resultsFilterBy([DBColumnsEnum.panel_brand], DBColumnsEnum.panel_brand)
      .subscribe(
        reslist => {
          let lst = reslist.map(function (item) {
            return item[DBColumnsEnum.panel_brand];
          });
          lst = lst.sort();
          //this.dbFilter.filterAdd(DBColumnsEnum.panel_brand, lst);
          let filter = new FilterItemCollection(DBColumnsEnum.panel_brand);
          filter.addItemsByList(lst);
          this.dbFilter.addFilter(filter);
        }
        , err => this.getSiteListhandleError(err)
      );
  }

  private drawPanelErrorsOnMapHandlerResult(superv: Supervision, reslist: SupervisionError[]) {
    let layerinfo: FrLayer = new FrLayer('Supervision ' + superv.name, superv.id, 17);
    let parentLayer = this.mapc.layerCreateVectorLayer(layerinfo);
    parentLayer.setStyle(this.mapSupervisionIssues.panelsFilterStyle.bind(this.mapSupervisionIssues));
    this.layer_Issues.push(parentLayer);
    this.mapc.layerAdd(parentLayer);

    let panelPattern = Site.getPanelPattern(superv.site, "maps");

    for (let x = 0; x < reslist.length; x++) {
      let obj: SupervisionError = reslist[x];
      obj.supervision = superv;
      MapSupervisionHelper.issuePolygonDraw(obj, parentLayer, panelPattern, true);
    }
    this.issueOverlay.layersId.push(superv.id);
    //this.mapc.setZoomToExtent(parentLayer);
    this.listerrmessage = "";
    this.loading = false;
  }

  //CHARTS START-------------------------------------------------------------------

  chartSitePowerData: any;
  chartSitePowerDataTable: any;
  //subtitle only works on material
  chartSitePowerOptions: any = {
    mainTitle:'Power by site in MW.',
    subtitle: 'Lost power is based on last supervision',
    legend: { position: 'bottom', maxLines: 3 },
    backgroundColor: 'transparent',
    chartArea: { width: '90%' },
    //width: 700,
    bar: { groupWidth: '68%' },
    isStacked: true,
    explorer: { axis: 'horizontal' },
    vAxis: { title: "MW" },
    hAxis: {
      direction: 1, slantedText: true, slantedTextAngle: 45, textPosition: "out"
      , textStyle: {
        fontSize: 9.5
      }
    }
    , annotations: {
      alwaysOutside: true,
      textStyle: {
        fontSize: 10,
        auraColor: 'none'
      }
    }

  };
  chartSitePowerOptionsExt: any = {
    height: "400px"
  }

  chart_sitepower(filterList) {
    console.log("chart_sitepower", filterList);
    const siteCount = filterList.length;
    let data = new this.gLib.visualization.DataTable();
    data.addColumn('string', 'id');
    data.addColumn('string', 'Site');
    data.addColumn('number', 'Peak Power');
    data.addColumn('number', 'Lost Power');
    
    if (siteCount > 6) {
      data.addColumn({ role: 'annotation' });
    }
    let lstSorted = filterList.slice().sort((a, b) => SortHelper.sortByStringLocale(a.name, b.name));
    for (let i = 0; i < lstSorted.length; i++) {
      let site: Site = lstSorted[i];
      let sitepower: number = 0;

      if (site.info.power != null) {
        sitepower = +site.info.power;
      }
      let sitepowerlost = 0;
      if (site.info.lastSupervisionSummary && site.info.lastSupervisionSummary.powerLost) {
        sitepowerlost = +site.info.lastSupervisionSummary.powerLost / 1000000;
      }
      if (siteCount > 6) {
        data.addRow([
          site.id,
          site.name,
          sitepower,
          sitepowerlost,
          site.name
        ]);
      } else {
        data.addRow([
          site.id,
          site.name,
          sitepower,
          sitepowerlost
        ]);
      }

    }

    const view = new google.visualization.DataView(data);
    let columns=[];
    columns.push({sourceColumn: 1,type: "string",role: "annotation"});
    columns.push({sourceColumn: 2,type: "number",role: "annotation"});
    columns.push({sourceColumn: 1,type: "string",role: "annotation"});
    if (siteCount > 6) {
    view.setColumns([1,2,3,4]);
    }else{
      view.setColumns([1,2,3]);
    }

    this.chartSitePowerDataTable=data;
    this.chartSitePowerData = view;
  }


  chartIssueTypeData: any;
  chartIssueTypeOptionsExt: any = {
    height: "400px"
  }
  //chartIssueTypeOptions = { "legend": "none" };
  chartIssueTypeOptions: any = {
    mainTitle: 'Issues by type.',
    subtitle: 'Based on last supervision.',
    /* legend: { position: 'bottom', maxLines: 3 }, */
    legend: 'none'
    , chartArea: { width: '75%' }
    , bar: { groupWidth: '75%' }
    , backgroundColor: 'transparent',
    isStacked: false,
    vAxis: { title: "Error count" },
    hAxis: {
      direction: 1, slantedText: true, slantedTextAngle: 45, textPosition: "out"
      , textStyle: {
        fontSize: 10
      }
    }
    , annotations: {
      alwaysOutside: true,
      textStyle: {
        fontSize: 10,
        auraColor: 'none'
      }
    }
    , tooltip: { isHtml: true }

  };
  chart_siteissues(source?: IDB_Chart_Res[]) {
    try {
      let data = new this.gLib.visualization.DataTable();
      data.addColumn('string', 'Issue');
      data.addColumn('number', 'Count');
      data.addColumn({ role: 'style' });
      data.addColumn({ type: 'string', role: 'tooltip', 'p': { 'html': true } });
      if (source) {
        let sourceOrdered: any[] = SortHelper.sortMultiple(source, ["count"], ['desc']); //_.orderBy(users, ['user', 'age'], ['asc', 'desc']);
        //console.log("chartIssueTypeData", sourceOrdered);
        for (let x = 0; x < sourceOrdered.length; x++) {
          let issueType = sourceOrdered[x]["issue_type"];
          let issueCount = +sourceOrdered[x]["count"];
          let issueDescription = DashBoardHelper.chartIssueDescription(issueType);
          let issueColor = IssueTypeHelper.issueGetErrorTypeColor(issueType);
          //data.addRow([sourceOrdered[x]["issue_type"], +sourceOrdered[x]["count"], DashBoardHelper.chartIssueColor(sourceOrdered[x]["issue_type"])]);
          let tooltip = '<div style="padding:5px 5px 5px 5px;"><b style="white-space: nowrap">' + issueDescription + '</b><br><span style="white-space: nowrap">Errors: <b>' + issueCount + '</span></b></div>';

          data.addRow([issueDescription, issueCount, issueColor, tooltip]);
        }
      }
      this.chartIssueTypeData = data;
    }
    catch (error) {

    }
  }



 

  chartIssueRelevanceData: any;
  chartIssueRelevanceOptions: any = {
    mainTitle: 'Issues by relevance.',
    backgroundColor: 'transparent'

  };
  chart_siteissuesrelevance(source?: IDB_Chart_Res[]) {
    try {
      let data = new this.gLib.visualization.DataTable();
      data.addColumn('string', 'Issue Relevance');
      data.addColumn('number', 'Quantity');
      data.addColumn({ role: 'style' });
      /*     data.addRows([
            ['Muy baja:	0 ºC ≤ Tc‐To < 10 ºC', 3],
            ['Baja:	10 ºC ≤ Tc‐To < 20 ºC', 6],
            ['Media:	20 ºC ≤ Tc‐To < 30 ºC', 4],
            ['Alta:	30 ºC ≤ Tc‐To < 100 ºC', 5],
            ['Muy alta:	Tc‐To ≥ 100 ºC', 2]
          ]); */
      if (source) {
        let sourceOrdered: any[] = SortHelper.sortMultiple(source, ["count"], ['desc']);
        for (let x = 0; x < sourceOrdered.length; x++) {
          let relevance = sourceOrdered[x]["relevance"];
          let count = +sourceOrdered[x]["count"];
          let color = IssueTypeHelper.issueGetRelevanceColor(relevance);
          data.addRow([relevance, count, color]);
        }
      }

      let view = new google.visualization.DataView(data);
      this.chartIssueRelevanceData = view;
    }
    catch (error) {

    }
  }

  chartIssueModuleBrandData: any;
  chartIssueModuleBrandOptions: any = {
    title: 'Issues by manufacturer.',
    backgroundColor: 'transparent'

  };
  chart_IssueModuleBrandData(source?: IDB_Chart_Res[]) {
    let data = new this.gLib.visualization.DataTable();
    data.addColumn('string', 'Brand');
    data.addColumn('number', 'Quantity');

    if (source) {
      let sourceOrdered: any[] = SortHelper.sortMultiple(source, ["count"], ['desc']); //_.orderBy(users, ['user', 'age'], ['asc', 'desc']);
      for (let x = 0; x < sourceOrdered.length; x++) {
        data.addRow([sourceOrdered[x][DBColumnsEnum.panel_brand], +sourceOrdered[x]["count"]]);//, this.chartIssueColor(sourceOrdered[x][0])]);
      }
    }
    this.chartIssueModuleBrandData = data;
  }


   chartIssueModuleTypeData: any;
  chartIssueModuleTypeOptions: any = {
    mainTitle: 'Issues by module.',
    backgroundColor: 'transparent'

  };
  chart_IssueModuleTypeData(source?: IDB_Chart_Res[]) {
    let data = new this.gLib.visualization.DataTable();
    data.addColumn('string', 'Module');
    data.addColumn('number', 'Quantity');

    if (source) {
      let sourceOrdered: any[] = SortHelper.sortMultiple(source, ["count"], ['desc']); //_.orderBy(users, ['user', 'age'], ['asc', 'desc']);
      for (let x = 0; x < sourceOrdered.length; x++) {
        data.addRow([sourceOrdered[x]["panel_model"], +sourceOrdered[x]["count"]]);//, this.chartIssueColor(sourceOrdered[x][0])]);
      }
    }
    this.chartIssueModuleTypeData = data;
  }




  configCompanyTotals() {
    this.companytotalsites = this.dashService.sitesAll.length;
    this.companytotalpower = 0;
    this.companytotalmodules = 0;
    for (const site of this.dashService.sitesAll) {
      let siteStats = DashboardService.calculateSiteStats(site);
      this.companytotalpower += siteStats.power;
      this.companytotalmodules += siteStats.modules;
      this.companytotalpowerlost += siteStats.powerlost;
      this.companytotalmodulesinactive += siteStats.modulesinactive;
    }
    this.companytotalpowerlost = this.companytotalpowerlost;
  }

  showLastSupervisions: boolean = false;
  last_inspections_close() {
    this.showLastSupervisions = !this.showLastSupervisions;

  }



  siteAutoComplete_optionSelected($event: Site) {
    console.log($event);
    let site: Site = $event;
    if (site) {
      this.filterDashBoardBySite(site);
      if (site.info.location) {
        this.mapc.setLocation(new FrCoordinate(site.info.location[0], site.info.location[1]));
        this.mapc.zoomUpgrade(17);
      }
    }
    else {
      this.filterDashBoardBySiteResetToAll();
    }
  }

  chart_sitepower1(filterList) {
    const siteCount = filterList.length;
    let data = new this.gLib.visualization.DataTable();
    data.addColumn('string', 'id');
    data.addColumn('string', 'Site');
    data.addColumn('number', 'Peak Power');
    data.addColumn('number', 'Lost Power');
    
    if (siteCount > 6) {
      data.addColumn({ role: 'annotation' });
    }
    let lstSorted = filterList.slice().sort((a, b) => SortHelper.sortByStringLocale(a.name, b.name));
    for (let i = 0; i < lstSorted.length; i++) {
      let site: Site = lstSorted[i];
      let sitepower: number = 0;

      if (site.info.power != null) {
        sitepower = +site.info.power;
      }
      let sitepowerlost = 0;
      if (site.info.lastSupervisionSummary && site.info.lastSupervisionSummary.powerLost) {
        sitepowerlost = +site.info.lastSupervisionSummary.powerLost / 1000000;
      }
      if (siteCount > 6) {
        data.addRow([
          site.id,
          site.name,
          sitepower,
          sitepowerlost,
          site.name
        ]);
      } else {
        data.addRow([
          site.id,
          site.name,
          sitepower,
          sitepowerlost
        ]);
      }

    }

    const view = new google.visualization.DataView(data);
    let columns=[];
    columns.push({sourceColumn: 1,type: "string",role: "annotation"});
    columns.push({sourceColumn: 2,type: "number",role: "annotation"});
    columns.push({sourceColumn: 1,type: "string",role: "annotation"});
    if (siteCount > 6) {
    view.setColumns([1,2,3,4]);
    }else{
      view.setColumns([1,2,3]);
    }

    this.chartSitePowerDataTable=data;
    this.chartSitePowerData = view;
  }


}
